import request from '@/utils/request'

const urlPrefix = '/monitor'

export function getMonitorProxyList (params) {
  return request.get(`${urlPrefix}/proxies`, { params })
}
